import {propTypes} from 'redux-form'
import styles from './MultipleDropdownSelect.css'

class MultipleDropdownSelect extends React.Component {
  render () {
    const {options} = this.props
    return (
      <div className={`btn-group ${styles.wrapper}`}>
        <button type='button'
          className='dropdown-toggle btn btn-default'
          data-toggle='dropdown'
          aria-haspopup='true'
          aria-expanded='false'>
          {this._dropdownSelectStatusLabel()} &nbsp;
          <span className='caret' />
        </button>
        <ul className='dropdown-menu'>
          {Object.keys(options).map((key, index) => {
            return (<li key={index} onClick={() => { this._onClick(key) }}>
              <a>
                {this._isSelected(key) &&
                <span className='glyphicon glyphicon-ok' />}
                {options[key]}
              </a>
            </li>)
          })}
        </ul>
      </div>)
  }

  _dropdownSelectStatusLabel = () => {
    const {input: {value}, placeholder} = this.props
    const isArray = !!value && value.constructor === Array

    if (!isArray) {
      return placeholder
    } else {
      if (value.length) {
        return `${value.length} checked`
      } else {
        return placeholder
      }
    }
  }

  _isSelected = (key) => {
    const {input: {value}} = this.props
    let isSelected = false
    const isArray = !!value && value.constructor === Array

    if (isArray) {
      value.forEach((v) => {
        isSelected = isSelected || (v === key)
      })
    }
    return isSelected
  }

  _onClick = (targetVal) => {
    const {input: {onChange, value}} = this.props
    const retVal = []
    let targetValExist = false
    const isArray = !!value && value.constructor === Array
    if (!isArray) {
      // immediately return 1 element array since the initial value is not array
      retVal.push(targetVal)
    } else {
      value.forEach((v) => {
        if (v === targetVal) {
          targetValExist = true
          // deselect - don't insert the value
        } else {
          retVal.push(v)
        }
      })
      if (!targetValExist) {
        retVal.push(targetVal)
      }
    }
    onChange(retVal)
  }
}

MultipleDropdownSelect.propTypes = {
  ...propTypes,
  options: React.PropTypes.object,
  placeholder: React.PropTypes.string
}
export default MultipleDropdownSelect



// WEBPACK FOOTER //
// ./app/components/Fields/ReduxForm/MultipleDropdownSelect/MultipleDropdownSelect.js